module.exports = __webpack_public_path__ + "img/caret-down-square.8f2f7dea.svg";